import { Nav } from "../components/Nav";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Pain } from "../components/sections/Pain";
import { Demo } from "../components/sections/Demo";
import { HowItWorks } from "../components/sections/HowItWorks";
import { WhatsInside } from "../components/sections/WhatsInside";
import { AIComparison } from "../components/sections/AIComparison";
import { Trust } from "../components/sections/Trust";
import { ProductContent } from "../components/sections/ProductContent";
import { Pricing } from "../components/sections/Pricing";
import { Faq } from "../components/sections/Faq";
import { FinalCta } from "../components/sections/FinalCta";
import { Footer } from "../components/sections/Footer";
import { StickyCta } from "../components/StickyCta";

export default function Landing() {
  return (
    <div className="min-h-screen bg-paper text-ink">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Pain />
        <Demo />
        <HowItWorks />
        <WhatsInside />
        <AIComparison />
        <Trust />
        <ProductContent />
        <Pricing />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
      <StickyCta />
    </div>
  );
}
